import { render } from "./EveryoneSocialCollectionData.vue?vue&type=template&id=58fde275&scoped=true"
import script from "./EveryoneSocialCollectionData.vue?vue&type=script&lang=js"
export * from "./EveryoneSocialCollectionData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fde275"]])

export default __exports__